import clsx from "clsx";

type NumericBadgeProps = {
  value: number;
  max?: number;
  color?: "red" | "blue" | "natural";
  className?: string;
};

const NumericBadge = ({ value, color = "red", max = value, className }: NumericBadgeProps) => {
  return (
    value > 0 && (
      <div
        className={clsx(
          "my-auto inline-flex min-w-4 select-none justify-center rounded px-1 py-0.5 text-5xs font-semibold",
          color === "red" && "bg-error-solid text-primary-brand",
          color === "blue" && "bg-brand-primary-solid text-primary-brand",
          color === "natural" && "border-primary bg-secondary text-primary",
          className,
        )}
      >
        {value > max ? `${max}+` : value}
      </div>
    )
  );
};

export default NumericBadge;
